import React from 'react';
import { SlidesListInput } from './SlidesListInput';

interface Slide {
  description: string;
}

interface SlidesFieldProps {
  label: string;
  required?: boolean;
  value: Slide[];
  onChange: (_value: Slide[]) => void;
  placeholder?: string;
  error?: string;
}

export const SlidesField: React.FC<SlidesFieldProps> = ({
  label,
  required = false,
  value,
  onChange,
  placeholder,
  error
}) => {
  return (
    <>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <SlidesListInput
        value={value}
        onChange={onChange}
        placeholder={placeholder}
      />
      {error && (
        <p className="text-red-500 text-sm mt-1">{error}</p>
      )}
    </>
  );
};

